/* אייקוני שלבי התהליך — נתיבי ה-SVG הועתקו מהאתר המקורי. */
import type { JSX } from 'react';
import classes from './StepIcon.module.css';
import type { StepIconName, StepIconProps } from './StepIcon.types';

const PATHS: Record<StepIconName, JSX.Element> = {
  discover: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m21 21-4.3-4.3" />
    </>
  ),
  team: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20a6 6 0 0 1 12 0" />
      <circle cx="17" cy="9" r="2.3" />
      <path d="M16 20a5 5 0 0 1 5-5" />
    </>
  ),
  map: (
    <>
      <path d="m9 4-6 2v14l6-2 6 2 6-2V4l-6 2-6-2z" />
      <path d="M9 4v14M15 6v14" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1.4" />
    </>
  ),
  fund: (
    <>
      <rect x="2" y="6" width="20" height="13" rx="1" />
      <circle cx="12" cy="12.5" r="3" />
      <path d="M6 6V4h12v2" />
    </>
  ),
  gears: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2" />
    </>
  ),
  graduate: (
    <>
      <path d="M22 9 12 4 2 9l10 5 10-5z" />
      <path d="M6 11v5c0 1.5 3 3 6 3s6-1.5 6-3v-5" />
    </>
  ),
};

export function StepIcon({ name }: StepIconProps) {
  return (
    <svg viewBox="0 0 24 24" className={classes.icon} aria-hidden="true" focusable="false">
      {PATHS[name]}
    </svg>
  );
}
